export default "__VITE_ASSET__DXI6toud__"